import * as React from "react";
const IconCloseOptions = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#7981B2"
      d="m11.169 10 6.085-6.085a.835.835 0 0 0 0-1.17.835.835 0 0 0-1.17 0L9.999 8.83 3.913 2.745a.835.835 0 0 0-1.17 0 .835.835 0 0 0 0 1.17L8.828 10l-6.085 6.085a.835.835 0 0 0 0 1.17c.17.17.383.234.596.234a.914.914 0 0 0 .596-.234l6.064-6.085 6.085 6.085c.17.17.383.234.595.234a.914.914 0 0 0 .596-.234.835.835 0 0 0 0-1.17L11.17 10Z"
    />
  </svg>
);
export default IconCloseOptions;
